import { createSelector } from "reselect";
import getSchoolNewFieldsSelector from "./getSchoolNewFieldsSelector";

export default createSelector(
    getSchoolNewFieldsSelector,
    (_: Store, field: string) => field,
    (newFields: GenericObject, field) => {
        return newFields[field];
    }
);
